import React from "react";
import { Formik, Field, Form } from "formik";
import { TextField, Loading, GalleryField } from "components/form";
import { required, validationWrapper, number } from "lib/formValidations";
import { transformTranslateFromValues } from "lib/helpers";
import Modal from "components/Modal";
import { TextArea, Select } from "components/form";
import { useCore } from "store/core";
// components

export default function Add(props) {
  const core = useCore();

  return (
    <>
      <Modal show={props.show} handleClose={props.close} title={props.title}>
        <Formik
          initialValues={{ parent_id: null }}
          onSubmit={async (values, { setSubmitting }) => {
            if(!values.parent_id)
            {
              delete values.parent_id;
            }
            values.type='PlusVod';
            await props.submit(transformTranslateFromValues(values));
            props.close();
            setSubmitting(false);
          }}
          enableReinitialize
        >
          {({ isSubmitting, dirty }) => (
            <Form>
              <div className="modal-body py-1 gap-y-3">
                <div className="intro-x md:grid md:grid-cols-2 md:gap-3">
                  <Field
                    label="والد"
                    name="parent_id"
                    component={Select}
                    options={
                      [
                        { value: null, label: "بدون والد" },
                        ...core.productCategories,
                      ] || []
                    }
                    validate={(value) => validationWrapper(value)}
                  />
                  <Field
                    placeholder="نام"
                    label="نام :"
                    name="name"
                    component={TextField}
                    validate={(value) => validationWrapper(value, required)}
                  />
                  <Field
                    placeholder="name"
                    label="نام انگلیسی :"
                    name="_en*name*text"
                    component={TextField}
                    validate={(value) => validationWrapper(value, required)}
                  />
                  <Field label="توضیحات" name="desc" component={TextArea} />
                  <Field
                    label="description"
                    name="_en*desc*text"
                    component={TextArea}
                  />
                  <Field
                    label="ترتیب"
                    name="order"
                    type="number"
                    component={TextField}
                    validate={(value) => validationWrapper(value, required)}
                  />
                </div>

                <div className="w-full flex justify-between">
                  <div className="w-5/12">
                    <Field
                      label="تصویر"
                      name="media_id"
                      dataType="id"
                      component={GalleryField}
                    />
                  </div>
                  <div className="w-5/12">
                    <Field
                      label="Image"
                      name="_en*media_id*media"
                      dataType="id"
                      component={GalleryField}
                    />
                  </div>
                </div>
                <div className="intro-y  col-span-12 sm:col-span-12 grid grid-cols-2 gap-x-2">
                <div className="intro-y">
                  <Field
                    label="توضیحات سئو(max 160 characters):"
                    name="seo_desc"
                    component={TextArea}
                  />
                </div>
                <div className="intro-y">
                  <Field
                    label="توضیحات انگلیسی سئو(max 160 characters):"
                    name="_en*seo_desc*text"
                    component={TextArea}
                  />
                </div>
                <div className="intro-y">
                  <Field
                    label="کلمات کلیدی سئو(مانند:سریال,اکشن):"
                    name="seo_keywords"
                    component={TextArea}
                  />
                </div>
                <div className="intro-y">
                  <Field
                    label="کلمات کلیدی انگلیسی سئو(مانند:serie,action):"
                    name="_en*seo_keywords*text"
                    component={TextArea}
                  />
                </div>
              </div>
                <div>
                  {core.slidersLoad ? (
                    <Loading />
                  ) : (
                    <Field
                      label="اسلایدر :"
                      name="slider_id"
                      valueOnly
                      component={Select}
                      options={core.sliders || []}
                    />
                  )}
                </div>
              </div>

              <div className="modal-footer text-right">
                <button
                  className="btn btn-primary w-20"
                  type="submit"
                  disabled={!!(isSubmitting || !dirty)}
                >
                  {" "}
                  {isSubmitting ? <Loading /> : "ذخیره"}
                </button>
                <button
                  type="button"
                  disabled={isSubmitting}
                  onClick={props.close}
                  className="btn btn-outline-secondary w-20 mr-1"
                >
                  انصراف
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
}
